import { useMutation } from '@apollo/client'
import { useEffect } from 'react'

import awsExports from '../../aws-exports'
import { useAmplitude } from '../use-amplitude'
import { EXPORT_TRANSACTIONS } from './queries'

export interface ExportTransactionsProps {
    /** Transactions type */
    type?: 'crypto' | 'bank'
    /** Filter transactions by account id */
    filter?: string
    /** Filter transactions by provider */
    providers?: string
}

export function useExportTransactions({
    type,
    filter,
    providers,
}: ExportTransactionsProps) {
    const { log } = useAmplitude()
    const secureProviders = providers ? [providers] : undefined
    const accountIds = filter ? [filter] : undefined
    const accountType = type ? type.toUpperCase() : undefined

    const [call, { data: exportTransactionsData, loading: exportLoading }] =
        useMutation(EXPORT_TRANSACTIONS, {
            variables: {
                input: {
                    providers: secureProviders,
                    accountIds,
                    accountType,
                },
            },
        })

    function getFileLocation(bucketKey: string) {
        const bucketName = awsExports.aws_user_files_s3_bucket
        const bucketRegion = awsExports.aws_user_files_s3_bucket_region
        return `https://${bucketName}.s3.${bucketRegion}.amazonaws.com/${bucketKey}`
    }

    const fileLocation =
        exportTransactionsData && exportTransactionsData.transactionsExport
            ? getFileLocation(exportTransactionsData.transactionsExport)
            : undefined

    useEffect(() => {
        if (fileLocation) log('EXPORT TRANSACTIONS LIST', { fileLocation })
    }, [fileLocation, log])

    return {
        call,
        fileLocation,
        loading: exportLoading,
    }
}
